import React from 'react';
import styled from 'styled-components';

import PersuasionHoverText from '../../../../../stories/components/hotels/SRP/PersuasionHoverText/PersuasionHoverText';

export interface IPersuasionText {
  pt: string;
  ccd?: IPersuasionColor;
  s;
  htd?: {
    h?: string;
    ht?: Array<string>;
    ft?: string;
    hec?: IPersuasionColor;
    hoc?: IPersuasionColor;
    ic?: string;
  };
  ic?: string;
}

export interface IPersuasionColor {
  tc?: string;
  bgc?: string;
}

const HotelCardDealTag = ({data}: {data: IPersuasionText}) => {
  return (
    <PersuasionHoverText
      data={[data]}
      wrapperStyles={`
        position: absolute;
        right: 2rem;
        top: -1rem;
      `}
      TriggerTextComponent={({persuasionData}) => {
        if (!persuasionData.pt) {
          return null;
        }

        let leftArrowSolidBorderColor: string;
        let rightArrowSolidBorderColor: string;

        const triggerTextColorFromSource = persuasionData.ccd?.bgc;
        const triggerTextBgColorPresent = typeof persuasionData.ccd?.bgc === 'string';

        if (
          triggerTextBgColorPresent &&
          typeof triggerTextColorFromSource === 'string' &&
          triggerTextColorFromSource.startsWith('linear-gradient')
        ) {
          const linearGradientSplitted = triggerTextColorFromSource.split(/\((.*?)\)/);
          const linearGradientInfo = (linearGradientSplitted[1] || '').split(',');

          if (linearGradientInfo.length > 2) {
            const directionRawInfo = linearGradientInfo[0];
            const followLeftToRightForColor =
              parseInt(directionRawInfo.replace('deg', 0)) < 90 ||
              directionRawInfo.split(' ')[1] === 'right';

            const colorsInOrderThatTheyCame = linearGradientInfo
              .map(el => el.trim())
              .map(el => el.split(' ')[0])
              .filter(el => el.startsWith('#') || el.startsWith('rgb'));

            if (followLeftToRightForColor) {
              leftArrowSolidBorderColor = colorsInOrderThatTheyCame[0];
              rightArrowSolidBorderColor = colorsInOrderThatTheyCame[1];
            } else {
              leftArrowSolidBorderColor = colorsInOrderThatTheyCame[1];
              rightArrowSolidBorderColor = colorsInOrderThatTheyCame[0];
            }
          }
        }

        return (
          <WrapperDiv gradient={persuasionData.ccd?.bgc} color={persuasionData.ccd?.tc}>
            <TagMarkup
              leftArrowSolidBorderColor={leftArrowSolidBorderColor}
              rightArrowSolidBorderColor={rightArrowSolidBorderColor}
            />
            {/* <ArrowDiv /> */}
            <TextWrapperSpan>{persuasionData.pt}</TextWrapperSpan>
            {/* <ArrowDiv /> */}
          </WrapperDiv>
        );
      }}
    />
  );
};
export default HotelCardDealTag;

const WrapperDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  /* position: absolute;
  right: 2rem;
  top: -1rem; */
  align-self: flex-start;
  background-image: ${props => props.gradient || 'linear-gradient(284deg, #adaeb2, #34393a)'};
  color: ${props => props.color};
  padding: ${props => props.theme.spacing.xsmall} ${props => props.theme.spacing.custom(4)}
    ${props => props.theme.spacing.xsmall} ${props => props.theme.spacing.custom(8)};
`;

const TextWrapperSpan = styled.span(
  props => `
  display: flex;
  flex-wrap: wrap;
  font-weight: bold;
  color: ${props.theme.colors.goWhite.base};
`,
);

const TagMarkup = styled.div(
  props => `
  &:before {
    content: '';
    border-top: 0.9rem solid transparent;
    border-right: 0.5rem solid ${props.leftArrowSolidBorderColor};
    position: absolute;
    left: -0.5rem;
    top: 0.1rem;
  }

  &:after {
    content: '';
    border-top: 0.9rem solid transparent;
    border-left: 0.5rem solid ${props.rightArrowSolidBorderColor};
    position: absolute;
    right: -0.5rem;
    top: 0.1rem;
  }
`,
);
